import CampaignDetailModal from "./CampaignDetailModal";
import CampaignDetailsCard from "./CampaignDetailsCard";
import { useState } from "react";

const CampaignDetailInfoCards = ({ campaignData, orderedData, navigate }) => {
  const [showCampaignDetailModal, setShowCampaignDetailModal] = useState(false);

  const toggleCampaignDetailModal = () => {
    setShowCampaignDetailModal(!showCampaignDetailModal);
  }

  return (<>
    {showCampaignDetailModal && <CampaignDetailModal {...campaignData} onClose={toggleCampaignDetailModal} />}
    <div className="campaign-detail-info-cards">
      <CampaignDetailsCard campaignData={campaignData} orderedData={orderedData} toggleCampaignDetailModal={toggleCampaignDetailModal} navigate={navigate} />
    </div>
  </>
  );
};

export default CampaignDetailInfoCards;
